var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
//
// Ensures that common attributes are rendered with the proper attribute names
// and buffered as necessary.
//
export const commonAttrs = (props) => {
    const { testID, style } = props, rest = __rest(props, ["testID", "style"]);
    return Object.assign({ 'data-testid': testID, style }, rest);
};
